export const API_URL = process.env.REACT_APP_API_URL;
export const API_KEY_TINY_MCE = process.env.REACT_APP_API_KEY_TINY_MCE;
export const ENVIRONMENT = process.env.REACT_APP_ENV; // expected values development, testing, production
export const DOMAIN = process.env.REACT_APP_DOMAIN;
export const CLIENTID =  process.env.REACT_APP_CLIENT_ID;
export const AUDIENCE = process.env.REACT_APP_AUDIENCE;
export const RETURNURL = process.env.REACT_APP_RETURNURL;